import api from '../../REST/api';
import createUiAction from '../../utils/create-ui-action';

export const initializeBalance = createUiAction(
  'balance/initialize',
  ({ opportunityId, latestTask }) =>
    Promise.all([
      api.getBookingEntries({ search: { opportunityId, unassigned: 1 } }),
      api.getInvoices({ search: { opportunityId } }),
    ]).then(([bookingEntries, invoices]) => ({
      bookingEntries,
      invoices,
      context: { latestTask, opportunityId },
    })),
);

export const updateLatestTask = createUiAction(
  'balance/update-latest-task',
  task => task,
);
